import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import App from "./App";
import { apolloClient, initAuthToken } from "./lib/apollo";
import { ToastProvider } from "./contexts/ToastContext";
import { ToastContainer } from "./components/Toast";
import { ConfirmProvider } from "./contexts/ConfirmContext";
import { ConfirmDialog } from "./components/ConfirmDialog";
import { SyncQueueProvider } from "./contexts/SyncQueueContext";
import { initStatusBar } from "./lib/statusBar";
import { initKeyboard } from "./lib/keyboard";
import { initFirebase } from "./lib/firebase";
import { initSentry, SentryErrorBoundary } from "./lib/sentry";
import { initPwaUpdate } from "./lib/pwaUpdate";
import { ready as liveUpdateReady, checkForUpdate } from "./lib/live-update";
import { Capacitor } from "@capacitor/core";
import "./index.css";

// Sentry는 가능한 빨리 초기화 (에러 캡처 누락 방지)
initSentry();

// 네이티브: Live Update (OTA), PWA: Service Worker 업데이트
if (Capacitor.isNativePlatform()) {
  liveUpdateReady().then(() => checkForUpdate());
} else {
  initPwaUpdate();
}

// 앱 시작 전 초기화: 인증 토큰 + Status Bar + Keyboard + Firebase
Promise.all([initAuthToken(), initStatusBar(), initKeyboard(), initFirebase()]).then(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <SentryErrorBoundary
        fallback={
          <div style={{ padding: 24, textAlign: "center" }}>
            <h2>오류가 발생했습니다</h2>
            <p>앱을 다시 시작해 주세요.</p>
            <button
              onClick={() => window.location.reload()}
              style={{
                marginTop: 16,
                padding: "8px 24px",
                borderRadius: 8,
                border: "1px solid #ccc",
                background: "#2563eb",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              새로고침
            </button>
          </div>
        }
      >
        <ApolloProvider client={apolloClient}>
          <SyncQueueProvider>
            <ToastProvider>
              <ConfirmProvider>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
                <ToastContainer />
                <ConfirmDialog />
              </ConfirmProvider>
            </ToastProvider>
          </SyncQueueProvider>
        </ApolloProvider>
      </SentryErrorBoundary>
    </React.StrictMode>
  );
});
